import {
  createRouter,
  createWebHistory,
} from 'vue-router';
import {
  SIGN_UP_ROUTE,
  SIGN_UP_ROUTE_V2,
} from '@/router/routes';

import { deepLinkRouterSegment } from '@/deepLinks';
import { v1RouterSegment } from '@/v1/router';
import { v2RouterSegment } from '@/v2/router';
import { analyticsStore } from '@/analytics/ampitude';

let routerInstance = null;

export default {
  createRouters() {
    const routes = [
      ...v1RouterSegment,
      ...v2RouterSegment,
      ...deepLinkRouterSegment,
      {
        path: '/:pathMatch(.*)*',
        name: 'not_found',
        redirect: (to) => {
          if (to.path.startsWith('/v2/')) {
            return SIGN_UP_ROUTE_V2;
          }
          return SIGN_UP_ROUTE;
        },
      },
    ];

    routerInstance = createRouter({
      history: createWebHistory(),
      routes,
    });

    routerInstance.beforeEach((to) => {
      analyticsStore.title = to.meta.amplitudeTitle ?? null;
    });

    return routerInstance;
  },
};
